import Image from "next/image";

type RenderIconProps = {
  icon?: string;
  size?: number;
  className?: string;
};

export function renderIcon({
  icon,
  size = 24,
  className = "",
}: RenderIconProps) {
  if (!icon || typeof icon !== "string") return null;

  // 1. Inline SVG string
  if (icon.trim().startsWith("<svg")) {
    return (
      <span
        className={`inline-block text-current ${className}`}
        style={{ width: size, height: size }}
        dangerouslySetInnerHTML={{ __html: icon }}
        aria-hidden="true"
      />
    );
  }
  // 2. External image URL
  if (/^https:\/\//.test(icon)) {
    return (
      <div
        className={`relative aspect-square ${className}`}
        style={{ width: size, height: size }}
        aria-hidden="true"
      >
        <Image
          src={icon}
          alt="icon"
          fill
          sizes={`${size}px`}
          className="object-contain"
        />
      </div>
    );
  }

  // 4. UTF-8 / Emoji / fallback
  return (
    <span
      className={`inline-block leading-none ${className}`}
      style={{ fontSize: size }}
      role="img"
      aria-label="icon"
    >
      {icon}
    </span>
  );
}
